<template>
    <div class="materialPurchase-box">
        <HeaderNav
            header-title="物资采购"
            left-icon-name="2"
            right-icon-name="2"
            @change-org="handleChangeOrg"
        ></HeaderNav>
        <monthSelectTitle :tit="title" @change-month="changeMonth"></monthSelectTitle>
        <!-- 弹出日历控件 -->
        <van-popup
            v-model="showCalendar"
            position="bottom"
            :style="{ height: '50%' }"
        >
            <van-datetime-picker
                v-model="currentDate"
                type="year-month"
                :formatter="formatter"
                :max-date="maxDate"
                @confirm="confirmMonth"
                @cancel="cancelMonth"
            ></van-datetime-picker>
        </van-popup>
        <div class="warpper">
            <h4 class="chart-title">
                采购价格趋势分析
            </h4>
            <!-- 图表1 -->
            <div id="priceLine"></div>
            <div class="split"></div>
            <h4 class="chart-title">
                <span>本月采购价格</span>
                <span class="subtitle">单位(元/吨)</span>
            </h4>
            <div class="price-table">
                <table
                    border="0"
                    cellspacing="1"
                    cellpadding="0"
                >
                    <tr class="theader">
                        <td>
                            分类
                        </td>
                        <td>
                            上月
                        </td>
                        <td>
                            本月
                        </td>
                        <td>
                            环比
                        </td>
                        <td>
                            核定
                        </td>
                    </tr>
                    <template v-for="item in tableData">
                        <tr class="row-item" :key="item.sort_num">
                            <td class="first-child" v-text="item.type_name"></td>
                            <td v-if="item.data[0].date !== month">
                                {{ item.data[0].price|currencyStyle('currency') }}
                            </td>
                            <td v-else>
                                {{ item.data[1].price|currencyStyle('currency') }}
                            </td>
                            <td v-if="item.data[0].date === month">
                                {{ item.data[0].price|currencyStyle('currency') }}
                            </td>
                            <td v-else>
                                {{ item.data[1].price|currencyStyle('currency') }}
                            </td>
                            <td :class="[{'down':item.chain_ratio<0},{'up': item.chain_ratio>0}]">
                                {{ item.chain_ratio|currencyStyle('currency')|absNum }}%
                                <span class="iconfont iconxiajiang" v-if="item.chain_ratio<0"></span>
                                <span class="iconfont iconshangsheng" v-else></span>
                            </td>
                            <td>{{ item.price_auth|currencyStyle('currency') }}</td>
                        </tr>
                    </template>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
import { HeaderNav } from '@/components/';
import monthSelectTitle from '@/components/header-nav/monthSelectTitle';
import utils from '@/assets/js/utils';
import { Dialog } from 'vant';
export default {
    name: 'material-purchase',
    components: {
        HeaderNav, monthSelectTitle,
    },
    data() {
        return {
            title: '', // 标题
            showCalendar: false, // 是否展示日历选择
            orgData: [], // 组织数据
            lineData: {}, // 折线图数据
            currentDate: new Date(), // 当前时间
            maxDate: '',
            orgId: '', // 当前组织ID
            year: '', // 年
            month: '', // 月
            tableData: [], // 表格数据
        };
    },
    methods: {
        priceLineChart(lineData, legendData) {
            // 基于准备好的dom，初始化echarts实例
            const myChart = this.$echarts.init(document.getElementById('priceLine'));
            // 指定图表的配置项和数据
            const option = {
                tooltip: {
                    trigger: 'axis',
                },
                legend: {
                    data: legendData,
                },
                color: ['#FA8436', '#5588F1', '#21BDCC', '#C64FDF', '#EB656F', '#7BB956', '#f6bd16', '#6dc8ec', '#ff99c3', '#8B6BEE'],
                grid: {
                    left: '2%',
                    right: '2%',
                    bottom: '3%',
                    containLabel: true,
                },
                xAxis: {
                    type: 'category',
                    axisLine: {
                        lineStyle: {
                            color: '#ccc',
                        },
                    },
                    splitLine: {
                        show: false,
                    },
                    axisTick: {
                        show: false,
                    },
                    splitArea: {
                        show: false,
                    },
                    axisLabel: {
                        interval: 0,
                        color: '#979EA7',
                    },
                    data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
                },
                yAxis: {
                    type: 'value',
                    name: '单位(元/吨)',
                    axisLabel: {
                        formatter: '{value}',
                        color: '#979EA7',
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#ccc',
                        },
                    },
                    axisTick: {
                        show: false,
                    },
                    splitArea: {
                        show: false,
                    },
                },
                series: lineData,
            };
            // 使用刚指定的配置项和数据显示图表。
            myChart.setOption(option, true);
        },
        // 按月下来筛选
        changeMonth() {
            this.showCalendar = true;
        },
        // 拉取每月采购情况
        getProureMonth() {
            this.$axios
                .get('/interfaceApi/report/ProcureManager/get_proure_month/' + this.year + '/' + this.month + '/' + this.orgId)
                .then(res => {
                    if (res) {
                        const map = {};
                        const dest = [];
                        for (let i = 0; i < res.length; i++) {
                            const ai = res[i];
                            if (!map[ai.type_name]) {
                                if (!ai.price) {
                                    ai.price = 0;
                                } else {
                                    ai.price = parseFloat(ai.price.toFixed(2));
                                }
                                dest.push({
                                    name: ai.type_name,
                                    type: 'line',
                                    data: [ai.price],
                                });
                                map[ai.type_name] = ai;
                            } else {
                                for (let j = 0; j < dest.length; j++) {
                                    const dj = dest[j];
                                    // eslint-disable-next-line max-depth
                                    if (dj.name === ai.type_name) {
                                        // eslint-disable-next-line max-depth
                                        if (!ai.price) {
                                            ai.price = 0;
                                        } else {
                                            ai.price = parseFloat(ai.price.toFixed(2));
                                        }
                                        dj.data.push(ai.price);
                                        break;
                                    }
                                }
                            }
                        }
                        const lineData = dest;
                        const legendData = [];
                        lineData.map(item => {
                            legendData.push(item.name);
                        });
                        this.priceLineChart(lineData, legendData);
                    }
                })
                .catch(error => {
                    Dialog({ message: error.ErrorCode.Message });
                });
        },
        // 切换运营区
        handleChangeOrg(value) {
            this.orgId = value;
            this.getProureMonth();
            this.getProureTwoMonth();
        },
        // 时间格式化
        formatter(type, val) {
            if (type === 'year') {
                return `${val}年`;
            } if (type === 'month') {
                return `${val}月`;
            }
            return val;
        },
        // 返回的时间格式化
        formatDate(date) {
            return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;
        },
        // 时间选择完成
        confirmMonth(value) {
            const timeStr = this.formatDate(value);
            const timeArr = timeStr.split('/');
            // eslint-disable-next-line radix
            this.year = parseInt(timeArr[0]);
            // eslint-disable-next-line radix
            this.month = parseInt(timeArr[1]);
            this.getProureMonth();
            this.getProureTwoMonth();
            this.showCalendar = false;
            this.title = this.year + '年' + this.month + '月份，中国联合水泥商混业务物资采购情况';
        },
        // 取消时间选择
        cancelMonth() {
            this.showCalendar = false;
        },
        // 拉取本月及上月采购情况
        getProureTwoMonth() {
            this.$axios
                .get('/interfaceApi/report/ProcureManager/get_proure_two_month/' + this.year + '/' + this.month + '/' + this.orgId)
                .then(res => {
                    if (res) {
                        const map = {};
                        let dest = [];
                        for (let i = 0; i < res.length; i++) {
                            const ai = res[i];
                            if (!map[ai.type_name]) {
                                dest.push({
                                    type_name: ai.type_name,
                                    type_code: ai.type_code,
                                    price: ai.price,
                                    price_auth: ai.price_auth,
                                    sort_num: ai.sort_num,
                                    data: [ai],
                                });
                                map[ai.type_name] = ai;
                            } else {
                                for (let j = 0; j < dest.length; j++) {
                                    const dj = dest[j];
                                    // eslint-disable-next-line max-depth
                                    if (dj.type_name === ai.type_name) {
                                        dj.data.push(ai);
                                        break;
                                    }
                                }
                            }
                        }
                        dest = dest.map(item => {
                            item.chain_ratio = 0;
                            if (item.data[0].date === this.month) {
                                if (item.data[1].price) {
                                    item.chain_ratio = ((item.data[0].price - item.data[1].price) / item.data[1].price * 100).toFixed(2);
                                }
                            } else if (item.data[1].date === this.month) {
                                if (item.data[0].price) {
                                    item.chain_ratio = ((item.data[1].price - item.data[0].price) / item.data[0].price * 100).toFixed(2);
                                }
                            }
                            return item;
                        });
                        this.tableData = dest;
                    }
                })
                .catch(error => {
                    Dialog({ message: error.ErrorCode.Message });
                });
        },
    },
    mounted() {
        const value = this.$store.state.orgData[0].value;
        this.orgId = value;
        const obj = utils.getPreMon();
        this.year = obj.year;
        this.month = obj.month;
        this.maxDate = new Date(obj.year, obj.month - 1, obj.lastDate);
        this.year = 2019;
        this.month = 12;
        this.getProureMonth();
        this.getProureTwoMonth();
        this.title = this.year + '年' + this.month + '月份，中国联合水泥商混业务物资采购情况';
    },
};
</script>

<style lang="stylus" scoped>
.materialPurchase-box
    padding-top 74rpx
    height calc(100% - 74rpx)
    .warpper
        height 100%
        overflow-x hidden
        overflow-y auto
        -webkit-overflow-scrolling touch
        .header
            width 100%
            height 30rpx
            background #F0F0F0
            font-size 12rpx
            text-align center
            line-height 30rpx
            .iconrili
                font-size 14rpx
                margin-right 6rpx
        .chart-title
            padding 15rpx 3% 10rpx
            font-size 16rpx
            position relative
            .subtitle
                float right
                color #979EA7
                font-size 10rpx
                padding-top 4rpx
        .split
            width 100%
            height 15rpx
            background #F0F0F0
        #priceLine
            width 98%
            height 320rpx
            margin 0 1% 5%
        .price-table
            width 100%
            padding 2rpx
            table
                width 100%
                border-spacing 0px
                border-collapse collapse
                td
                    border 2.5rpx solid #fff
                    border-collapse collapse
                    height 45rpx
                    text-align center
                    width 73rpx
                    font-size 12rpx
                .theader
                    td
                        background rgba(33,189,204,0.1)
                        color #21BDCC
                .row-item
                    td
                        background #F0F0F0
                    .first-child
                        background rgba(250,132,54,0.1)
                    .down
                        color #21BDCC
                        .iconfont
                            font-size 12rpx
                    .up
                        color #EB656F
                        .iconfont
                            font-size 12rpx

</style>